import React, { Component } from 'react';
import { Row, Col, Form, InputGroup, Label, Button, Container } from "reactstrap";
import lscache from 'lscache'
import { inject, observer } from "mobx-react/index";
import { Filtro, Visualizar, FecharFiltro } from "../../comum/components/Icones";
import CalendarioPicker from '../../comum/components/Calendario';
import moment from 'moment';
import Card from '../../comum/components/Card';
import InputFiltro from '../../comum/components/InputFiltro';

@inject("store")
@observer
export default class FiltrosProgramacao extends Component {
    constructor(props) {
        super(props);
        {/* TODO: inserir proptypes */ }
    }

    render() {
        {/* TODO : melhorar no mobile */ }
        return (
            <Container fluid>
                <Card>
                    <div className="filtros ml-0">
                        <Form>
                            <Row className="align-items-end ">
                                {!this.props.situacaoBerco &&
                                    <Col xs={{ size: 12, order: 1 }}
                                        xl={{ size: 3, order: 1 }}
                                        md={{ size: 4, order: 1 }}
                                        sm={{ size: 6, order: 1 }}
                                        className="mb-1">
                                        <div className="w-100">
                                            <Col xs={12} className="col-label px-0">
                                                <Label>Período</Label>
                                            </Col>

                                            <Col xs={"auto"} className="px-0">
                                                <InputGroup className={this.props.seletorPeriodo ? 'ativo' : ''}>
                                                    <CalendarioPicker visivel={this.props.seletorPeriodo}
                                                        onChangeInicio={this.props.onChangeDataInicio}
                                                        onChangeFim={this.props.onChangeDataFim}
                                                        dataInicial={this.props.dataInicial}
                                                        dataFinal={this.props.dataFinal}
                                                        fechar={this.props.toggleDataSeletor}
                                                        filtrar={this.props.filtrarData} />
                                                </InputGroup>

                                            </Col>
                                        </div>
                                    </Col>
                                }

                                {lscache.get('access_token') && <Col className="mb-1" xs={{ size: "auto", order: 2 }}>
                                    <div className="">
                                        <Col xs={12} className="col-label px-0">
                                            <Label>Visualização</Label>
                                        </Col>
                                        <Col xs={12} className="px-0">
                                            <Button className="btn-filtros" onClick={this.props.clickBtnFiltro} outline>
                                                <Filtro color="#93A0AD"
                                                    className="mr-2"
                                                    width="15"
                                                    height="15" />
                                                    Customizar
                                                </Button>
                                        </Col>
                                    </div>

                                </Col>}

                                <Col className="mb-1" xs={{ size: "auto", order: 3 }}>
                                    <div className="">
                                        <Col xs={12} className="col-label px-0">

                                        </Col>
                                        <Col xs={12} className="px-0">
                                            <Button className={this.props.situacaoBerco ? " ativo btn-filtros" : "btn-berth btn-filtros"}
                                                outline
                                                onClick={this.props.alternarSituacaoBerco}>
                                                {this.props.situacaoBerco
                                                    ? <React.Fragment>
                                                        <FecharFiltro />
                                                        <span className="btn-label">Fechar</span>
                                                    </React.Fragment>
                                                    : <BotaoVisualizar />}
                                            </Button>
                                        </Col>
                                    </div>
                                </Col>

                                <Col className="mb-1 ml-lg-auto order-xs-1 justify-content-end px-0"
                                    sm={{ order: 4 }} xs={{ size: "auto", order: 4 }} md={{ size: 6, order: 4 }} lg={{ size: 2, order: 4 }} xl={{ size: 4, order: 4 }}
                                >
                                    <InputFiltro
                                        className="mb-1"
                                        value={this.props.controller.pesquisaViagem}
                                        xl={12} md={12} sm={12} xs={12}
                                        placeholder="Digite o Navio, Viagem, Serviço ou Armador"
                                        onChange={event =>
                                            this.props.controller.setFiltroSelecionado("search", event.target.value)
                                        }
                                    />
                                </Col>
                            </Row>

                        </Form>
                    </div>
                </Card>
            </Container>
        )
    }
}

function BotaoVisualizar() {
    if (process.env.rig) {
        return (
            <React.Fragment>
                <Visualizar tamanho='lg' />
                <span className="btn-label">Berth Situation</span>
            </React.Fragment>
        )
    } else {
        return (
            <React.Fragment>
                <Visualizar tamanho='lg' />
                <span className="btn-label">Situação de Berço</span>
            </React.Fragment>)

    }
}


// WEBPACK FOOTER //
// ./src/modules/programacao/components/FiltrosProgramacao.js